export class productStyle {
  id: number;
  styleName: string;
  thumbnail: string;
  baseCategory: number;
  elemente: [
      {id: number, element_name: string, width: number, height: number, option_type: string, image: string}
      ]
}